import React, { useState, useEffect } from 'react';
import {Modal, Button, Table, Input, Select, Space, Row, Col, message, Popconfirm, AutoComplete} from 'antd';
import {DeleteOutlined} from "@ant-design/icons";
import UIFetchService from "../Service/UIFetchService";
import { isEmpty, isNotEmpty } from '../Service/Utils';

const { Option } = Select;

const TraceChannel = (props) => {

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [searchKey, setSearchKey] = useState(null)
    const [channelLevels, setChannelLevels] = useState([])
    const [allChannels, setAllChannels] = useState([])
    const [channels, setChannels] = useState([]); // Assuming channels state is provided or initialized somewhere
    const [allChannelNames, setAllChannelNames] = useState([])

    useEffect(() => {
        const init  = async() => {
            await fetchChannelLevels()
            await fetchChannels()
            await fetchAllChannelNames()
        }

        init().catch(console.error)
    }, [])

    useEffect(() => {
        filterChannels(searchKey)
    }, [searchKey, allChannels, allChannelNames])

    const fetchChannelLevels = async () => {
        const res = await UIFetchService.get('/api/v1/trace/channel/levels')
        setChannelLevels(res)
    }

    const fetchChannels = async () => {
        const res = await UIFetchService.get('/api/v1/trace/channels')
        setAllChannels(res)
        setChannels(res)
    }

    const filterChannels = (key) => {
        setSearchKey(key)

        const filteredChannels = isNotEmpty(key) ? allChannels.filter(c => c.channelName.includes(key) || c.channelId.includes(key) || c.creator.includes(key)) : allChannels
        filteredChannels.forEach(fc => {
            fc.channelNameOptions = allChannelNames.length > 0 ? allChannelNames.filter(cn => cn.channelName.includes(fc.channelName)) : []
        })

        setChannels(filteredChannels)
    }

    const fetchAllChannelNames = async () => {
        const res = await UIFetchService.get('/api/v1/trace/channel/nameOptions')
        // console.info(res.map(r => r.channelName))
        setAllChannelNames(res)
    }

    const addChannel = () => {
        const minId = Math.min(...channels.map(c => c.id), 0)

        const newChan = {
            id: minId - 1,
            channelLv1: null,
            channelLv2: null,
            channelCode: null,
            channelName: '',
            channelId: '',
            team: null,
            remark: '',
            channelNameOptions: allChannelNames.map(c => { return {label: c.channelName, value: c.channelName }})
        }

        setChannels([newChan, ...channels])
    }

    const handleOk = () => {
        if (!checkSave()) {
            message.error('请将渠道信息填写完成')
            return
        }

        UIFetchService.post('/api/v1/trace/channels', channels)
            .then(res => {
                if (res != null) {
                    message.success('渠道信息保存成功')
                }
            })

        props.onCancel()
    };

    const checkSave = () => {
        for (const channel of channels) {
            if (channel.channelLv1 == null ||
                channel.channelLv2 == null ||
                isEmpty(channel.channelName) ||
                isEmpty(channel.channelId) ||
                isEmpty(channel.team)) {

                return false
            }
        }

        return true
    }

    const handleCancel = () => {
        props.onCancel()
    };

    const getSubChannels = (channelLv1) => {
        const channel = channelLevels.find(cl => cl.id === channelLv1)
        if (channel == null) {
            return []
        }

        return channel.subChannels
    }

    const deleteChannel = (id, index) => {
        UIFetchService.delete(`/api/v1/trace/channel/${id}`)
            .then(res => {
                if (res != null) {
                    message.success("删除成功")
                    setChannels([
                        ...channels.slice(0, index),
                        ...channels.slice(index + 1)
                    ])
                }
            })
    }

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            width: 60,
            key: 'id',
            render: (cid) => cid > 0 ? <span>{cid}</span> : null

        },
        {
            title: <>一级渠道<span style={{color: 'red'}} > &nbsp;*</span></>,
            dataIndex: 'channelLv1',
            key: 'channelLv1',
            width: 150,
            render: (cid, record, index) => <Select
                style={{ width: '100%' }}
                value={cid}
                onChange={value => {
                    setChannels([
                        ...channels.slice(0, index),
                        {...record, channelLv1: value, channelLv2: null},
                        ...channels.slice(index + 1)
                    ])
                }}
            >
                {channelLevels.map(cl => <Option key={cl.id} value={cl.id} >{cl.name}</Option>)}
            </Select>,
        },
        {
            title: <>二级渠道<span style={{color: 'red'}} > &nbsp;*</span></>,
            dataIndex: 'channelLv2',
            key: 'channelLv2',
            width: 150,
            render: (cid, record, index) => <Select
                style={{ width: '100%' }}
                value={cid}
                onChange={value => {
                    setChannels([
                        ...channels.slice(0, index),
                        {...record, channelLv2: value},
                        ...channels.slice(index + 1)
                    ])
                }}
            >
                {record.channelLv1 != null && getSubChannels(record.channelLv1).map(cl => <Option key={cl.id} value={cl.id} >{cl.name}</Option>) }
            </Select>,
        },
        {
            title: <>渠道名称<span style={{color: 'red'}} > &nbsp;*</span></>,
            dataIndex: 'channelName',
            key: 'channelName',
            width: 180,
            render: (text, record, index) => (
                <AutoComplete
                    allowClear
                    showSearch
                    placeholder="请输入/选择，回车确定"
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    value={text}
                    onChange={value => {
                        const newRecord = {...record}
                        newRecord.channelName = value
                        const filteredChannelNames = allChannelNames.filter(c => c.channelName.includes(value))
                        newRecord.channelNameOptions = filteredChannelNames.map(c => { return {label: c.channelName, value: c.channelName} })
                        const opt = allChannelNames.find(o => o.channelName === value)
                        if (opt != null) {
                            newRecord.channelCode = opt.appId
                        }
                        setChannels([
                            ...channels.slice(0, index),
                            newRecord,
                            ...channels.slice(index + 1)
                        ])
                    } }

                    options={record.channelNameOptions}
                />
            ),
        },
        {
            title: <>渠道标识<span style={{color: 'red'}} > &nbsp;*</span></>,
            dataIndex: 'channelId',
            key: 'channelId',
            width: 150,
            render: (text, record, index) => <Input value={text} onChange={e => {
                setChannels([
                    ...channels.slice(0, index),
                    {...record, channelId: e.target.value},
                    ...channels.slice(index + 1)
                ])
            }} />,
        },
        {
            title: '说明',
            dataIndex: 'remark',
            key: 'remark',
            width: 150,
            render: (text, record, index) => <Input value={text} onChange={e => {
                setChannels([
                    ...channels.slice(0, index),
                    {...record, remark: e.target.value},
                    ...channels.slice(index + 1)
                ])
            }} />,
        },
        {
            title: <>所属团队<span style={{color: 'red'}} > &nbsp;*</span></>,
            dataIndex: 'team',
            key: 'team',
            width: 150,
            render: (text, record, index) => <Select
                placeholder="所属团队"
                value={text}
                style={{ width: '100%' }}
                onChange={value => {
                    setChannels([
                        ...channels.slice(0, index),
                        {...record, team: value},
                        ...channels.slice(index + 1)
                    ])
                }}
            >
                { props.teams.map( team => <Select.Option key={team} value={team}> {team} </Select.Option>) }
            </Select>,
        },
        {
            title: '创建人',
            dataIndex: 'creator',
            key: 'creator',
        },
        {
            title: '创建时间',
            dataIndex: 'createdAt',
            key: 'createdAt',
        },
        {
            title: '',
            key: 'action',
            width: 80,
            render: (text, record, index) => (
                <Space size="middle">
                    <Popconfirm title="确认删除该渠道吗？"
                        onConfirm={() => {
                            deleteChannel(record.id, index)
                        }}
                    >
                    <Button
                        icon={<DeleteOutlined />}
                        size='small'
                        type="link"
                        danger
                    />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <>
            <Modal
                title="渠道管理"
                open={props.visible}
                width={1500}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button key="back" onClick={handleCancel}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleOk}>
                        确定
                    </Button>,
                ]}
            >
                <Row>
                    <Col flex="300px">
                        <Input
                            placeholder="输入渠道名称/标识/创建人查询"
                            value={searchKey}
                            onChange={e => setSearchKey(e.target.value)}
                            style={{ marginBottom: 10 }} />
                    </Col>
                    <Col flex='auto'></Col>
                    <Col>
                        <Button type="primary" onClick={addChannel}>
                            新增渠道
                        </Button>
                    </Col>
                </Row>

                <Table className='trace-channel-table'
                       scroll={{y: 600}}
                       pagination={false}
                       dataSource={channels}
                       columns={columns} />
            </Modal>
        </>
    );
};

export default TraceChannel;